<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'right-angled-triangle-mirrored', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const base = computed({
	get: () => dimensions.value.base,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "base",
			value: value,
		});
	},
});

const height = computed({
	get: () => dimensions.value.height,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="right-angled-triangle-mirrored-base"
			:id="`${prefix}measurements-right-angled-triangle-mirrored-base`"
			:name="`${prefix}measurements[dimensions][base]`"
			unit="cm"
			:label="dimensionLabel('width', 'right-angled-triangle-mirrored')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}right-angled-triangle-mirrored-base`)"
			:onBlur="() => addSizeToDataLayer('base', +base, 'right-angled-triangle-mirrored')"
			v-model="base"
		/>

		<dimension-input
			inputRef="right-angled-triangle-mirrored-height"
			:id="`${prefix}measurements-right-angled-triangle-mirrored-height`"
			:name="`${prefix}measurements[dimensions][height]`"
			unit="cm"
			:label="dimensionLabel('height', 'right-angled-triangle-mirrored')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height')"
			:invalid="!isDimensionValid(`${prefix}right-angled-triangle-mirrored-height`)"
			:onBlur="() => addSizeToDataLayer('height', +height, 'right-angled-triangle-mirrored')"
			v-model="height"
		/>
	</shape-input-fields-wrapper>
</template>
